import { useLazyGetBlobsQuery } from '@consigli/hooks';
import { useDownloadFilesAsZip } from '@consigli/hooks';
import { DocumentPackage, Blob, DocumentType } from '@consigli/types';
import { useCallback } from 'react';

/**
 * Hook for downloading all files from a document package as a ZIP file
 */
export const useDownloadPackageZip = () => {
  const [getBlobs] = useLazyGetBlobsQuery();
  const { downloadFileZip, isDownloading } = useDownloadFilesAsZip('document-package', true);

  const downloadPackageAsZip = useCallback(
    async (documentPackage: DocumentPackage, projectId: number) => {
      try {
        const result = await getBlobs({
          projectId,
          packageId: documentPackage.id,
          page: 'all',
        }).unwrap();

        // Convert blobs to documents format expected by downloadFileZip
        const documents = result.results.map((blob: Blob) => ({
          id: blob.id,
          name: blob.name,
          downloadUrl: blob.downloadUrl,
          type: DocumentType.BLOB as const,
          extension: blob.extension,
          fileUrl: blob.fileUrl,
          documentPackageId: blob.documentPackage,
          ns3451: blob.ns3451,
          parsedData: blob.parsedData,
          convertedPdfFileId: blob.convertedPdfFileId,
        }));

        await downloadFileZip(documents);
      } catch (error) {
        console.error('Error downloading package as ZIP:', error);
        throw error;
      }
    },
    [getBlobs, downloadFileZip],
  );

  return {
    downloadPackageAsZip,
    isDownloading,
  };
};
